import type { BucketFileMetadata, UpdateMultipleBucketMetadataData } from '@/entities/bucket';
import request from '@/shared/api/request';

export const updateMultipleBucketMetadata = (
  name: string,
  data: Partial<UpdateMultipleBucketMetadataData>,
): Promise<{ metadata: BucketFileMetadata }> =>
  request({
    url: `/buckets/${name}/objects/metadata/`,
    method: 'POST',
    data,
  });
